/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Step_3Inputs */

const en_svc_research_step_3 = /** @type {(inputs: Svc_Research_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test it against questions you already know the answer to.`)
};

const lv_svc_research_step_3 = /** @type {(inputs: Svc_Research_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudām to ar jautājumiem, uz kuriem atbildi jau zināt.`)
};

/**
* | output |
* | --- |
* | "Test it against questions you already know the answer to." |
*
* @param {Svc_Research_Step_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_step_3 = /** @type {((inputs?: Svc_Research_Step_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Step_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_step_3(inputs)
	return en_svc_research_step_3(inputs)
});